import React from "react";
import styled from "styled-components";
import { Colors } from "../../config/Constants";

interface Props {
  iconPath: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  label: string;
}

const ActionImageButton = ({ iconPath, onClick, label }: Props) => {
  return (
    <StyledActionButton onClick={onClick}>
      <Label>{label}</Label>
      <img src={iconPath} alt="actionImage" />
    </StyledActionButton>
  );
};
const Label = styled.span`
  color: ${Colors.red};
  padding: 0;
  font-weight: 600;
  display: none;
  @media only screen and (max-width: 768px) {
    display: block;
  }
`;

const StyledActionButton = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0;
  gap: 0.25rem;
`;

export default ActionImageButton;
